import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export interface TaxPreparationStepProps {
  title: string;
  subtitle: string;
  description: string;
}

export function TaxPreparationStep(props: TaxPreparationStepProps) {
  const { title, subtitle, description } = props;
  return (
    <Stack direction="column" spacing={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text semibold variant="body1">
          {title}
        </Text>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text variant="caption">{subtitle}</Text>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text variant="body2" sx={{ marginTop: 3 }}>
          {description}
        </Text>
      </Stack>
    </Stack>
  );
}
